import styled from 'styled-components';

type DividerType = 'line' | 'partition';
type DividerColorType = 'light' | 'dark';

interface DividerProps {
  type: DividerType;
  gap?: number;
  colorType?: DividerColorType;
  fullWidth?: boolean;
  customStyle?: React.CSSProperties;
}

/**
 * 해당 컴포넌트는 기본적으로 부모의 width값을 100%로 따라갑니다.
 * 좌우 여백이 필요한 경우, props "gap"에 숫자값을 입력해주세요
 * ex) gap={20} // 좌우 값 20
 * @param {DividerType} type {('line' | 'partition')}
 * @param {Number} gap 디바이더의 좌우 여백이 있는경우, 넘버값으로 입력\
 * @param {DividerColorType} colorType {('light' | 'dark')}
 * @param {Boolean} fullWidth 디바이더의 width를 100vw로 원할 경우, 기본값은 false
 * @param {React.CSSProperties} customStyle 커스텀 스타일
 *
 * */
export function HorizontalDivider(props: DividerProps): JSX.Element {
  const { type, gap, colorType, fullWidth, customStyle } = props;
  return (
    <DivideShape
      style={customStyle}
      type={type}
      gap={gap}
      fullWidth={fullWidth}
      colorType={colorType ?? 'light'} />
  );
}

const DivideShape = styled.div`
  width: ${(props) =>
    props.gap
      ? `calc(${props.fullWidth ? '100vw' : '100%'} - ${props.gap * 2}px)}`
      : `${props.fullWidth ? '100vw' : '100%'}`};
  height: ${(props) => (props.type === 'line' ? '1px' : '12px')};
  display: flex;
  flex-shrink: 0;
  margin: 8px 0;
  background-color: ${(props) =>
    props.colorType === 'light'
      ? props.theme.colors.g100
      : props.theme.colors.g200};
`;
